"use strict";

exports.__esModule = true;
exports.TrackingError = void 0;
var _ConversionUtils = require("../Utils/ConversionUtils");
var _SessionError2 = require("../internal/SessionError");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /*
 * COPYRIGHT 2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
/**
 * An object containing details of any tracking errors that get reported.
 *
 * @hideconstructor
 */
var TrackingError = exports.TrackingError = /*#__PURE__*/function (_SessionError) {
  _inheritsLoose(TrackingError, _SessionError);
  function TrackingError(url, errorCode, event, adBreakId, mediaId) {
    var _this;
    _this = _SessionError.call(this, (0, _ConversionUtils.millisToTimestamp)(Date.now())) || this;
    _this.adBreakIdentifier = adBreakId;
    _this.url = url;
    _this.errorCode = errorCode;
    _this.event = event;
    _this.mediaIdentifier = mediaId || "";
    return _this;
  }

  /**
   * @returns {string} the break identifier of the AdBreak, if defined.
   * May be an empty string
   */
  var _proto = TrackingError.prototype;
  _proto.getAdBreakIdentifier = function getAdBreakIdentifier() {
    return this.adBreakIdentifier;
  }

  /**
   * @returns {string} the media identifier, if defined.
   * May be an empty string
   */;
  _proto.getMediaIdentifier = function getMediaIdentifier() {
    return this.mediaIdentifier;
  }

  /**
   * @returns {string} tracking URL without macro substitutions.
   * May be an empty string or malformed URL.
   */;
  _proto.getUrl = function getUrl() {
    return this.url;
  }

  /**
   * @returns {number} the error code result of the request. Valid error codes are:
   * - An HTTP status code not in the 200 range.
   * - -1: failed to establish an HTTP connection.
   * - -2: failed to complete connection or read the HTTP response before a timeout occurred.
   * - -3: the request URL is malformed.
   */;
  _proto.getErrorCode = function getErrorCode() {
    return this.errorCode;
  }

  /**
   * @returns {string} tracking event name ('firstQuartile', etc.).
   */;
  _proto.getEvent = function getEvent() {
    return this.event;
  };
  return TrackingError;
}(_SessionError2.SessionError);